module.exports = __webpack_public_path__ + "img/2.ea5255e9.svg";